<div id="flipbookContainer"></div>
<ng-container *ngIf="isLoading; else viewInfo">
  <div fxLayout="column" fxLayoutAlign="center center" class="height-100">
    <uni-loader></uni-loader>
  </div>
</ng-container>
<ng-template #viewInfo>
  <div *ngFor="let item of modules">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px" class="module-title-wrapper">
      <h3 class="font-lg font-bold spacing sparro-grey-900 margin-0">{{ item.sub_heading | uppercase }} </h3>
      <mat-divider class="width-100 border-top-width-2"></mat-divider>
    </div>

    <div class="desc-wrapper">
      <div class="content-desc sparro-grey-900" [innerHtml]="item.desc | safeContent"></div>
    </div>

    <div *ngIf="item.button_submodule">
      <div *ngFor="let buttonModule of item.button_submodule;">
        <div class="divider-section" fxLayout="row" fxLayoutAlign="center center">
          <i class="icon-3-horizontal-dots-fill sparro-grey-800"></i>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px" class="module-title-wrapper">
          <h3 class="font-lg font-bold spacing sparro-grey-900 margin-0">{{ buttonModule.sub_heading | uppercase }} </h3>
          <mat-divider class="width-100 border-top-width-2"></mat-divider>
        </div>

        <div fxLayout="row"  fxLayoutAlign="center center" fxLayoutGap="100px" class="margin-1">
          <div *ngFor="let item of buttonModule.buttons; index as i">
            <ng-container *ngIf="item.link.endsWith('.pdf'); else button">
              <div class="_df_thumb" attr.source="{{ item.link }}" style="display: none;" #pdf></div>
              <div class="link-button"  thumb="" (click)="loadPdfReader(i)">{{ item.title }}</div >
            </ng-container>
            <ng-template #button>
              <!-- <a class="link-button" href="{{ item.link }}" style="padding: 10px 15px" target="_blank">{{ item.title }}</a> -->
              <uni-navigation-button
                default="{{ item.title | uppercase }}"
                button_class="secondary"
                (click)="openLink(item.link)">
              </uni-navigation-button>
            </ng-template>
          </div>
        </div>

        <div class="text-center sparro-grey-800 button-desc-wrapper" *ngIf="buttonModule.desc">
          <div class="button-desc" [innerHtml]="buttonModule.desc | safeContent"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
